import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';
import { DropboxService } from 'src/app/services/dropbox.service';

@Component({
	selector: 'app-welcome-trial-form',
	templateUrl: './trial-form.component.html',
	styleUrls: ['./trial-form.component.css']
})
export class WelcomeTrialFormComponent implements OnInit {
	@ViewChild('inputClientId') inputClientId: ElementRef;
	@ViewChild('inputOauthSecret') inputOauthSecret: ElementRef;
	@ViewChild('inputApiKey') inputApiKey: ElementRef;
	@ViewChild('inputEmail') inputEmail: ElementRef;
	@ViewChild('selectUsersType') selectUsersType: ElementRef;


	loading = false;

	form: UntypedFormGroup;

	accountType = 'shared'; 	// shared = provide an account, connector = use my account
	usersType = 'OAUTH'; 		// OAUTH, OAUTHG

	clientIdValid: boolean;
	oauthSecretValid: boolean;
	apiKeyValid: boolean;
	emailValid: boolean;

	errorEmailAddress = false;

	constructor(
		private fb: UntypedFormBuilder,
		private clientService: ClientService,
		public contextService: ContextService,
		private dropboxService: DropboxService,
		private router: Router
	) { }

	ngOnInit() {
		this.initForm();
	}

	/** FORM FUNCTIONS */

	initForm() {
		this.emailValid = null;

		if (this.accountType == 'shared') {
			// Provide an account
			this.form = this.fb.group({
				accountType: new UntypedFormControl('shared', [Validators.required]),
				usersType: new UntypedFormControl(this.usersType, [Validators.required]),
				email: new UntypedFormControl('', [Validators.required, Validators.email]),
				clientId: new UntypedFormControl('', []),
				oauthSecret: new UntypedFormControl('', []),
				apiKey: new UntypedFormControl('', []),
			});
		} else {
			// Use my account
			this.form = this.fb.group({
				accountType: new UntypedFormControl('connector', [Validators.required]),
				usersType: new UntypedFormControl(this.usersType, [Validators.required]),
				email: new UntypedFormControl('', []),
				clientId: new UntypedFormControl('', [Validators.required]),
				oauthSecret: new UntypedFormControl('', [Validators.required]),
				apiKey: new UntypedFormControl('', [Validators.required]),
			});
		}
	}

	doClientIdValidation(e: any) {
		if (e.target.value) {
			this.clientIdValid = true;
		} else {
			this.clientIdValid = false;
		}
	}

	doOauthSecretValidation(e: any) {
		if (e.target.value) {
			this.oauthSecretValid = true;
		} else {
			this.oauthSecretValid = false;
		}
	}

	doApiKeyValidation(e: any) {
		if (e.target.value) {
			this.apiKeyValid = true;
		} else {
			this.apiKeyValid = false;
		}
	}

	doEmailValidation(e: any) {
		let emailValue = '';
		if (e.target?.value) {
			emailValue = e.target.value;
		} else {
			emailValue = e;
		}
		const regexPattern: RegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (regexPattern.test(emailValue)) {
			this.emailValid = true;
		} else {
			this.emailValid = false;
		}
	}

	/** CHANGE LISTENERS */

	changeAccountType(event) {
		this.accountType = event.srcElement.value;

		this.initForm();
	}

	changeUsersType(event) {
		this.usersType = event.srcElement.value;
	}

	/** BUTTON ACTIONS */

	selectTrialContinue() {
		this.loading = true;

		if (this.accountType == 'connector') {
			this.signupExistingAccount();
		} else {
			this.signupNewAccount();
		}
	}

	selectBack() {
		this.router.navigate(['/welcome/type']);
	}

	signupExistingAccount() {
		let clientDetailProcore;

		clientDetailProcore = {
			'clientId': this.contextService.clientDetailProcore.clientId,
			'companyId': this.contextService.procoreContextObject.context.company_id,
			'dropboxSignAPIKey': this.inputApiKey.nativeElement.value,
			'dropboxSignClientId': this.inputClientId.nativeElement.value,
			'dropboxSignOAUTHClientSecret': this.inputOauthSecret.nativeElement.value,
			'dropboxSignAccountType': this.selectUsersType.nativeElement.value,
			'subscriptionType': this.accountType
		};

		this.clientService.updateClientDetailProcore(clientDetailProcore, true)
			.subscribe((clientDetailProcore) => {
				this.router.navigate(['/welcome/authenticate'], { queryParams: { accountType: this.accountType, } });
			});
	}

	signupNewAccount() {
		this.dropboxService.assignUserToSharedTeam(this.inputEmail.nativeElement.value, this.contextService.procoreContextObject.context.company_id, this.selectUsersType.nativeElement.value, true)
			.subscribe((response) => {
				console.log(response);
				if (response == true) {
					// The user was invited to the team
					this.router.navigate(['/welcome/authenticate'], { queryParams: { accountType: this.accountType, } });
				} else {
					// The user wasn't invited to the team
					this.errorEmailAddress = true;
					this.loading = false;
				}
			});
	}
}
